import { gql } from './types/generated/gql';

export const TEAM_FRAGMENT = gql(`
  fragment TeamFields on Team {
    id
    name
    shortName
    abbreviation
  }
`);
